var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31960_147957)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31960_147957",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0L20.5 0V20H0.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31960_147957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 10.0007C20.5002 4.47747 16.0227 0 10.4995 0C4.97625 0 0.498779 4.47747 0.498779 10.0007C0.498779 14.6908 3.7276 18.6262 8.08355 19.7069V13.0568H6.02133V10.0007H8.08355V8.68385C8.08355 5.27993 9.62398 3.70222 12.9658 3.70222C13.5994 3.70222 14.6926 3.82643 15.1398 3.95068V6.72103C14.9038 6.69619 14.4938 6.68375 13.9845 6.68375C12.3446 6.68375 11.711 7.30491 11.711 8.9199V10.0007H14.9776L14.4165 13.0568H11.711V19.9282C16.6628 19.3301 20.5002 15.1138 20.5002 10.0007Z",
    fill: "#0866FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4169 13.0577L14.9781 10.0016H11.7115V8.92081C11.7115 7.30582 12.3451 6.68469 13.9849 6.68469C14.4942 6.68469 14.9042 6.69709 15.1402 6.72194V3.95162C14.693 3.82737 13.5998 3.70312 12.9662 3.70312C9.62442 3.70312 8.08395 5.28088 8.08395 8.68479V10.0016H6.02173V13.0577H8.08395V19.7078C8.85773 19.8998 9.66678 20.0023 10.4999 20.0023C10.9101 20.0023 11.3143 19.9771 11.7115 19.9291V13.0577H14.4169Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31960_147957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconCircle);
export default __webpack_public_path__ + "static/media/facebookIconCircle.ab2ad883f4b53063e6a392f4f5891582.svg";
export { ForwardRef as ReactComponent };